export default "__VITE_ASSET__976e9669__"